import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import { mutationEditorQuestionVerify } from 'gql/mutations/editor';
import { getQuestionInfo } from 'questions';

import QuestionToApprove from './QuestionToApprove';

const QuestionToApproveContainer = ({ question, ...props }) => {
  const handleQuestionVerify = useCallback(() => {
    mutationEditorQuestionVerify(question);
  }, [question]);
  const questionInfo = getQuestionInfo(question.type);
  return (
    <QuestionToApprove
      handleQuestionVerify={handleQuestionVerify}
      question={question}
      questionInfo={questionInfo}
      {...props}
    />
  );
};

QuestionToApproveContainer.propTypes = {
  className: PropTypes.string,
  question: PropTypes.object.isRequired,
};

QuestionToApproveContainer.defaultProps = {
  className: undefined,
};

export default React.memo(QuestionToApproveContainer);
